import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Image, Badge } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LinesEllipsis from "react-lines-ellipsis";
import StarRatings from "react-star-ratings";
import _ from "lodash";
import moment from "moment";

// Helper
import { weekdays } from "../../helpers/Constant";

// Component
import Color from "../../assets/color";
import Icon from "../../components/Icon";
import Link from "../../components/Link";

// UI Component
import MenuCard from "../MenuCard";

// Styles
import { RestaurantListCard } from "./style";

class RestaurantCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookmark: this.props.restaurantDetail.bookmark,
      showAllDeliveryDiscount: false,
    };
  }

  _goToRestaurantMenu = (id) => {
    const { restaurantDetail } = this.props;
    this.props.history.push(
      `/restaurant/${restaurantDetail.restaurant_id}/menu?id=${id}`
    );
  };

  _renderOpenStatus = () => {
    const { restaurantDetail } = this.props;
    // const todayWeekday = moment().isoWeekday(Number);

    let status = "Closed";
    let type = "danger";

    if (
      restaurantDetail.RestaurantBusinessHours &&
      restaurantDetail.RestaurantBusinessHours.length
    ) {
      if (restaurantDetail.openNow) {
        status = "Open Now";
        type = "primary";
      } else if (
        restaurantDetail.RestaurantSetting.preorder === true &&
        restaurantDetail.RestaurantSetting.preorder_now !== true
      ) {
        status = "Open Now";
        type = "primary";
      } else {
        // Not in business hour
        if (restaurantDetail.next_open_tms) {
          let isToday = moment(restaurantDetail.next_open_tms).isSame(moment());
          let nextOpenWeekday = moment(
            restaurantDetail.next_open_tms
          ).isoWeekday();
          let time = moment(restaurantDetail.next_open_tms).format("hh:mm A");
          status =
            "Closed until " +
            (isToday ? "today" : weekdays[nextOpenWeekday].name) +
            " " +
            time;
        }

        // Temporary Close
        if (restaurantDetail.temporary_close_to != null) {
          let isToday = moment(restaurantDetail.temporary_close_to).isSame(
            moment()
          );
          // let nextOpenWeekday = moment(
          //   restaurantDetail.temporary_close_to
          // ).isoWeekday(Number);

          status =
            "Temporary Closed until " +
            (isToday
              ? "today " +
                moment(restaurantDetail.temporary_close_to).format("hh:mm A")
              : moment(restaurantDetail.temporary_close_to).format(
                  "DD-MM-YYYY hh:mm A"
                ));
        }
      }
    }

    return (
      <Badge pill variant={type} className="badge-status">
        {status}
      </Badge>
    );
  };

  _onShowMore = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.props.onShowMore();
  };

  _substituteBookmark = (restaurantID) => {
    let currentBookmark = this.state.bookmark;
    this.setState(
      {
        bookmark: currentBookmark === 0 ? 1 : 0,
      },
      () => this.props.substituteBookmark(restaurantID)
    );
  };

  _substituteDoNotShow = (restaurantID) => {
    this.props.substituteDoNotShow(restaurantID);
  };

  _onCopy = () => this.props.onCopy();

  render() {
    const {
      restaurantDetail,
      showSearch,
      showMore,
      onClick,
      lololIDURL,
    } = this.props;
    const { bookmark, showAllDeliveryDiscount } = this.state;

    let profileImage = require("./../../assets/img/lolol-bg-white.png");

    if (restaurantDetail.Media.length) {
      let image = _.find(restaurantDetail.Media, (x) => x.type === "profile");

      if (image !== undefined) {
        profileImage = image.path;
      }
    }

    let restaurantLink = `/restaurant/?restaurant=${restaurantDetail.restaurant_id}`;
    if (this.props.orderType) {
      restaurantLink = `/restaurant/?restaurant=${restaurantDetail.restaurant_id}&type=${this.props.orderType}`;
    }
    let lastDeliveryFeeDiscount = null;

    if (restaurantDetail.RestaurantSetting) {
      if (restaurantDetail.RestaurantSetting.delivery_discount) {
        let lastIndex =
          restaurantDetail.RestaurantSetting.delivery_discount.length - 1;
        let lastItem =
          restaurantDetail.RestaurantSetting.delivery_discount[lastIndex];

        if (lastItem) {
          if (lastItem.cash) {
            lastDeliveryFeeDiscount = `RM ${lastItem.cash}`;
          }
          if (lastItem.discount) {
            lastDeliveryFeeDiscount = `${lastItem.discount}%`;
          }
        }
      }
    }

    return (
      <RestaurantListCard>
        <Link
          className="restaurant-list-card"
          to={restaurantLink}
          onClick={onClick}
        >
          {/* Show More */}
          {showMore && (
            <div
              className="preference"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div className="preference-type">
                <div
                  className="icon"
                  onClick={() =>
                    this._substituteBookmark(restaurantDetail.restaurant_id)
                  }
                >
                  <Icon
                    type="custom"
                    name={bookmark === 0 ? "bookmark" : "star"}
                    size={32}
                    color={Color.white}
                  />
                </div>
                <h4>Bookmark</h4>
              </div>
              <div className="preference-type">
                <div
                  className="icon"
                  onClick={() =>
                    this._substituteDoNotShow(restaurantDetail.restaurant_id)
                  }
                >
                  <Icon
                    type="custom"
                    name="dontshow"
                    size={32}
                    color={Color.white}
                  />
                </div>
                <h4>Don't Show</h4>
              </div>
              <div className="preference-type">
                <CopyToClipboard
                  text={`https://lolol.com/restaurant/?restaurant=${restaurantDetail.restaurant_id}${lololIDURL}`}
                  onCopy={() => this._onCopy()}
                >
                  <div className="icon">
                    <Icon
                      type="custom"
                      name="share"
                      size={32}
                      color={Color.white}
                    />
                  </div>
                </CopyToClipboard>
                <h4>Share</h4>
              </div>
            </div>
          )}
          {/* END Show More */}
          <div className="card-wrapper">
            <div className="inner-container restaurant-header">
              <div className="flex-grow-1">
                <LinesEllipsis
                  text={restaurantDetail.restaurant_name}
                  maxLine="1"
                  ellipsis="..."
                  component="h4"
                  className="restaurant-name"
                  basedOn="letters"
                />

                <StarRatings
                  rating={parseInt(restaurantDetail.avg_rating)}
                  starRatedColor={Color.primary}
                  starEmptyColor={Color.athens}
                  starDimension="15px"
                  starSpacing="1px"
                />
              </div>
              {this.props.hideButton === true ? null : (
                <div
                  className={`more ${showMore ? "show" : ""} flex-shrink-0`}
                  onClick={(e) => this._onShowMore(e)}
                >
                  <Icon
                    name="ios-more"
                    size={25}
                    color={showMore ? Color.white : Color.black}
                  />
                </div>
              )}
            </div>
            {/* END .inner-container */}

            <div className="image-container">
              {/* Flag */}
              <div className="flags">
                {(restaurantDetail.restaurant_recommended ||
                  restaurantDetail.RestaurantSetting.preorder) && (
                  <div className="flag-wrapper special-flags-wrapper">
                    {restaurantDetail.restaurant_recommended && (
                      <div>
                        <Badge pill variant="primary">
                          Recommended
                        </Badge>
                      </div>
                    )}
                    {restaurantDetail.RestaurantSetting.preorder && (
                      <div>
                        <Badge pill variant="light">
                          Pre-Order
                        </Badge>
                      </div>
                    )}
                  </div>
                )}
                <div className="flag-wrapper open-status-wrapper special-flags-wrapper">
                  {this._renderOpenStatus()}
                  {restaurantDetail.isNewRestaurant === 1 && (
                    <div>
                      <Badge
                        pill
                        variant="primary"
                        style={{ backgroundColor: "#03a9f4", width: 65 }}
                      >
                        NEW
                      </Badge>
                    </div>
                  )}
                </div>
              </div>
              {/* END Flag */}
              <Image className="image" src={profileImage} alt="" />
              {/* Dietary */}
              {restaurantDetail.RestaurantSetting && (
                <div className="dietary-container">
                  {/* Halal */}
                  {restaurantDetail.RestaurantSetting.halal && (
                    <div className="icon">
                      <Icon
                        type="custom"
                        name="halal"
                        size={35}
                        color={Color.emperor}
                      />
                    </div>
                  )}
                  {/* END Halal */}

                  {/* No Pork */}
                  {restaurantDetail.RestaurantSetting.pork_free && (
                    <div className="icon">
                      {/* <Icon
                        type="custom"
                        name="nopork"
                        size={35}
                        color={Color.emperor}
                      /> */}
                      <img
                        style={{
                          height: 35,
                          width: 35,
                        }}
                        src={require("../../assets/img/muslim_friendly_BW.png")}
                        alt=""
                      />
                    </div>
                  )}
                  {/* END No Pork */}

                  {/* Vegetarian */}
                  {restaurantDetail.RestaurantSetting.vegetarian && (
                    <div className="icon">
                      <Icon
                        type="custom"
                        name="vege"
                        size={35}
                        color={Color.emperor}
                      />
                    </div>
                  )}
                  {/* END Vegetarian */}
                </div>
              )}
              {/* END Dietary */}
            </div>
            {/* END .image-container */}

            <div className="inner-container">
              {/* Category */}
              {/*  <div className="category-container">
                {restaurantDetail.category.map((data, index) => {
                  return (
                    <div className="category" key={index}>
                      <Icon
                        type="font-awesome"
                        name="circle"
                        size={6}
                        color={Color.emperor}
                      />
                      <span className="label">{data}</span>
                    </div>
                  );
                })}
              </div> */}
              {/* END Category */}

              {/* Order Type */}
              {restaurantDetail.RestaurantSetting && (
                <React.Fragment>
                  <div className="order-type-container">
                    {/* Delivery */}
                    {restaurantDetail.RestaurantSetting.delivery && (
                      <div className="order-type">
                        <Icon
                          type="custom"
                          name="delivery"
                          color={Color.black}
                        />
                        <span className="label">Delivery</span>
                      </div>
                    )}
                    {/* END Delivery */}

                    {/* Dine In */}
                    {restaurantDetail.RestaurantSetting.dine_in && (
                      <div className="order-type">
                        <Icon type="custom" name="dinein" color={Color.black} />
                        <span className="label">Dine In</span>
                      </div>
                    )}
                    {/* END Dine In */}

                    {/* Pick Up */}
                    {restaurantDetail.RestaurantSetting.pick_up && (
                      <div className="order-type">
                        <Icon type="custom" name="pickup" color={Color.black} />
                        <span className="label">Pick Up</span>
                      </div>
                    )}
                    {/* END Pick Up */}

                    {/* Reservation */}
                    {restaurantDetail.RestaurantSetting.table_reserve && (
                      <div className="order-type">
                        <Icon
                          type="custom"
                          name="reservation"
                          color={Color.black}
                        />
                        <span className="label">Reservation</span>
                      </div>
                    )}
                    {/* END Reservation */}

                    {/* Scan & Pay */}
                    {restaurantDetail.RestaurantSetting.snp && (
                      <div className="order-type">
                        <Icon type="custom" name="pay" color={Color.black} />
                        <span className="label">Scan & Pay</span>
                      </div>
                    )}
                    {/* END Scan & Pay */}
                  </div>

                  {/* Delivery Fee Discount */}
                  {restaurantDetail.RestaurantSetting.delivery &&
                    restaurantDetail.RestaurantSetting.delivery_discount !==
                      null && (
                      <div className="delivery-discount-container">
                        <div
                          className="delivery-discount-label"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.setState({
                              showAllDeliveryDiscount: !this.state
                                .showAllDeliveryDiscount,
                            });
                          }}
                        >
                          <p className="mb-0">
                            Delivery Fee Discount up to{" "}
                            {lastDeliveryFeeDiscount}
                          </p>

                          <div className="icon">
                            <Icon
                              type="font-awesome"
                              name={
                                showAllDeliveryDiscount
                                  ? "angle-up"
                                  : "angle-down"
                              }
                              size={25}
                              color={Color.black}
                            />
                          </div>
                        </div>

                        {showAllDeliveryDiscount && (
                          <div className="delivery-discount-info">
                            <h5>Delivery Fee Discount Information</h5>
                            <ul className="delivery-discount-list">
                              {restaurantDetail.RestaurantSetting.delivery_discount.map(
                                (data, index) => {
                                  let discValue = "";

                                  if (data.cash) {
                                    discValue = `RM ${data.cash}`;
                                  }

                                  if (data.discount) {
                                    discValue = `${data.discount}%`;
                                  }

                                  let discText = `Above RM ${data.spend},  delivery fee discount ${discValue}`;

                                  return (
                                    <li key={index}>
                                      <span>
                                        <Icon
                                          type="font-awesome"
                                          name={"circle"}
                                          size={6}
                                          color={Color.primary}
                                        />
                                      </span>
                                      <span className="text">{discText}</span>
                                    </li>
                                  );
                                }
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  {/* END Delivery Fee Discount */}
                </React.Fragment>
              )}
              {/* END Order Type */}

              {showSearch && (
                <React.Fragment>
                  {/* Menu */}
                  {restaurantDetail.ItemMenus &&
                    restaurantDetail.ItemMenus.length !== 0 && (
                      <div className="food-menu">
                        <h5 className="title">
                          Food Menu: ({restaurantDetail.ItemMenus.length})
                        </h5>
                        {restaurantDetail.ItemMenus.map((data, index) => {
                          return (
                            <MenuCard
                              key={index}
                              data={data}
                              firstItem={index === 0}
                              showDescription={false}
                              showServingPeriod={false}
                              showDiscount={false}
                              showOrderButton={false}
                              onClick={() =>
                                this._goToRestaurantMenu(data.item_id)
                              }
                            />
                          );
                        })}
                      </div>
                    )}
                  {/* END Menu */}

                  {/* Restauarant Voucher */}
                  {restaurantDetail.SpecialPackages &&
                    restaurantDetail.SpecialPackages.length !== 0 && (
                      <div className="restaurant-voucher">
                        <h5 className="title">Vouchers:</h5>
                        {restaurantDetail.SpecialPackages.map((data, index) => {
                          return (
                            <div key={index} className="voucher">
                              <LinesEllipsis
                                text={data.package_title}
                                maxLine="1"
                                ellipsis={<span> ...</span>}
                                trimRight
                                basedOn="letters"
                                component="h5"
                                className="package-name"
                              />
                              <div className="price">
                                <p className="package-price">
                                  RM {parseFloat(data.package_price).toFixed(2)}
                                </p>
                                <p className="item-price">
                                  RM {parseFloat(data.item_price).toFixed(2)}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  {/* END Restauarant Voucher */}
                </React.Fragment>
              )}
            </div>
            {/* END .inner-container */}
          </div>
          {/* END .card-wrapper */}
        </Link>
        {/* END .restaurant-list-card */}
      </RestaurantListCard>
    );
  }
}

RestaurantCard.propTypes = {
  restaurantDetail: PropTypes.object.isRequired,
  showSearch: PropTypes.bool,
};

export default withRouter(RestaurantCard);
